module.exports = __webpack_public_path__ + "static/media/TableLeg_Before.33a30255.jpg";